import React from 'react'
import { Loader } from '@web/walter-ui-kit'

import styles from './style.module.css'
import Row from './Row'
import { useCommonCMSConfig } from '~api'

const minRowCount = 2

function Preloader() {
    const rowCount = useCommonCMSConfig().data?.locales?.length ?? minRowCount

    return (
        <div className={styles.wrap}>
            <div className={styles.header}>
                <Loader borderRadius="s" width={145} height={18} />
            </div>

            <div className={styles.content}>
                {Array.from(new Array(rowCount)).map((_, index) => (
                    <Row key={index} isSelected={index === 0} />
                ))}
            </div>
        </div>
    )
}

export default Preloader
